export const orderReplacementCard = {
    enableAddContactModal: false,
};
